import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { useParams } from "react-router"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"
import { ReturnToEditingDialog } from "./return-to-editing-dialog"
import { returnDraftToEditing } from "authoring/routes/project/schedule-editor/controller/return-draft-to-editing"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { isAlreadyPublishedNewSchedule } from "authoring/lib/enum/new-schedule-creation-type.mjs"

export function ReturnToEditing() {
    const { projectId } = useParams()
    const { targetId: scheduleId, status, canAccessReview, target, schedule } = useBoundContext()
    const openReturnToEditingDialog = useDialog(<ReturnToEditingDialog />)

    const sentToLegacy = isLockedToLegacy(target?.phase)
    const isPublishedNewSchedule = isAlreadyPublishedNewSchedule(schedule) || Boolean(schedule?.publishedId)

    if (status !== DraftStatus.APPROVED || !canAccessReview || !!sentToLegacy || isPublishedNewSchedule) return null
    if (target?.archived) return null

    return (
        <ContextMenuItem
            icon="mdi:undo"
            label="Return to Editing"
            onClick={handleReturnToEditing}
            data-cy="return-to-editing-button"
        />
    )

    async function handleReturnToEditing() {
        try {
            const dialogResult = await openReturnToEditingDialog()
            if (dialogResult) {
                const result = await returnDraftToEditing({
                    projectId,
                    scheduleId,
                    reason: dialogResult.reason,
                })
                if (result) {
                    successSnackbar("Schedule returned to editing successfully")
                } else {
                    errorSnackbar("Failed to return schedule to editing")
                }
            }
        } catch (error) {
            errorSnackbar(error?.message ?? "Failed to return schedule to editing")
        }
    }
}
